import styled from "styled-components";

export const ContainerWrapper = styled.div`
  .comman-tabel-view {
    height: calc(100vh - 180px);
  }

  .table-full-view {
    height: calc(100vh - 284px);
  }
`;

export const TableWrapperStyles = styled.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  padding: 8px 0 0 0;

  .filter-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;

    .search-dropdown-styles {
      display: flex;

      .search-input {
        border-radius: 0 24px 24px 0;
        border-right: none;
      }

      .search-select {
        border-radius: 24px 0 0 24px;

        input {
          padding: 8px;
        }
      }
    }

    .filter-bar-menus {
      display: flex;
      flex-direction: row;
      gap: 8px;

      .status-width {
        min-width: 160px;
      }
      .service-width {
        min-width: 210px;
      }
    }
  }
`;
